import firedux from '../firedux'
import {dispatch} from '../store'

import {
  CONVERSATION_STACKS_ENDPOINT
} from '../../config/constants'

import setConversationStack from '../actions/set_conversation_stack'
import getViewport from '../getters/viewport'

const onConversationStack = (snapshot) => {
  const stack = snapshot.val()

  dispatch(setConversationStack(stack))
}

export const watchConversationStack = (uid) => {
  const {type} = getViewport()
  const ref = firedux.ref.child(CONVERSATION_STACKS_ENDPOINT).child(type).child(uid)

  ref.on('value', onConversationStack)
}

export const unwatchConversationStack = (uid) => {
  const {type} = getViewport()
  const ref = firedux.ref.child(CONVERSATION_STACKS_ENDPOINT).child(type).child(uid)

  ref.off('value', onConversationStack)
  dispatch(setConversationStack([]))
}




/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/conversation_stack.js
 **/